module.exports = __webpack_public_path__ + "img/FR11315.9042a4b5.png";